import { PortfolioDTO } from "../DTO/portfolioDTO";
import { PropertyAbstract } from "./propertyAbstract";

export class Portfolio {
    public id?: number;
    public businessId!: string;
    public name!: string;
    public propertyIdList:number[] = [];
    public history?:PortfolioHistory[];
    public added?:Date;
    public edited?:Date;
    public addedByUser?:string;
    public lastEditedByUser?:string;

    public propertyAbstracts:PropertyAbstract[] = [];
    public tags:Map<string,string[]> = new Map<string,string[]>();

    private tagNames:string[] = ["caseNo"];

    constructor(){
        this.tagNames.forEach(tagName=>{
            this.tags.set(tagName, []);
        });
    }

    public static mapToDTO(param:Portfolio) : PortfolioDTO{
            
            let dto = new PortfolioDTO();
            try
            {
                dto.id = param.id;
                dto.businessId = param.businessId;
                dto.name = param.name;
                dto.propertyIdList = param.propertyIdList;
                dto.history = param.history ? JSON.stringify(param.history) : "";
                if(param.added) dto.added = param.added.toISOString();
                if(param.edited) dto.edited = param.edited.toISOString();
                dto.addedByUser = param.addedByUser;
                if(param.lastEditedByUser) dto.lastEditedByUser = param.lastEditedByUser;
            }
            catch(e)
            {
                console.log(e);
            }
            return dto;
    }
    public static mapFromDTO(param:PortfolioDTO) : Portfolio
    {
        
        let obj = new Portfolio();
        try
        {
            obj.id = param.id;
            obj.businessId = param.businessId;
            obj.name = param.name;
            obj.propertyIdList = param.propertyIdList;
            obj.history = param.history ? JSON.parse(param.history) : [];
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
            obj.addedByUser = param.addedByUser;
            if(param.lastEditedByUser) obj.lastEditedByUser = param.lastEditedByUser;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public addProperty(p:PropertyAbstract){
        if(!this.propertyAbstracts.find(x=>x.id === p.id)){
            this.propertyAbstracts.push(p);
            // Iterate through all tag names and update the tags map
            this.tagNames.forEach(tagName => {
                const propertyTagValue = (p as any)[tagName];
                // Check if the property has a value for this tag name
                if (propertyTagValue) {
                    const tagValues = this.tags.get(tagName);
                    
                    // Add the value if it's not already in the array
                    if (tagValues && tagValues.indexOf(propertyTagValue) === -1) {
                        tagValues.push(propertyTagValue);
                    }
                }
            });
        }
    }

    public removeProperty(p:PropertyAbstract){
        this.propertyAbstracts = this.propertyAbstracts.filter(x=>x.id !== p.id);
    }

    public findMatchingPortfolio(propertyTags:Map<string,string>): boolean {
        return this.tagNames.some(tagName => {
            const tagValues = this.tags.get(tagName);
            if (!tagValues || tagValues.length === 0) {
                return false;
            }
            // Get the property's value for this tag name
            const propertyTagValue = propertyTags.get(tagName);
            // Check if the property's value matches any of the tag values
            return propertyTagValue && tagValues.includes(propertyTagValue);
        });
    }

}

export class PortfolioHistory{
    public propertyId!:number;
    public timestamp!:Date;
    public action!:string;
    public byUser!:string;
    public reason!:string;
}